import {API_ROOT_URL} from 'envs/_current/config'
import {createTransform} from './utils/createTransform'
import {schema} from "normalizr";
import {createListTransform} from "./utils/createListTransform";

export const entityRoleSchema = new schema.Entity(
    'entity_roles',
    {},
    {idAttribute: 'id'}
)


export const entityRole_getList_Api = {
    backend: `// Route::get('entity-roles/{type}/{id}/fetch', 'EntityRoleController@getList')`,
    root: API_ROOT_URL,
    path: '/entity-roles/:type/:id/fetch',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    paramsFields: ['keyword'],
    schema: entityRoleSchema,
    transform: createListTransform(entityRoleSchema),
}

export const entityRole_getById_Api = {
    backend: `// Route::get('entity-roles/detail/{role_id}/get', 'EntityRoleController@getById')`,
    root: API_ROOT_URL,
    path: '/entity-roles/detail/:role_id/get',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    transform: createTransform(entityRoleSchema, 'data'),
}

export const entityRole_getSchema_Api = {
    backend: `// Route::get('entity-roles/schema/{type}/{id}', 'EntityRoleController@getSchema')`,
    root: API_ROOT_URL,
    path: '/entity-roles/schema/:type/:id',
    method: 'GET',
    fields: [],
    fieldTypes: {},
    transform: createTransform(entityRoleSchema, 'data'),
}

export const entityRole_create_Api = {
    backend: `// Route::post('entity-roles/{type}/{id}/create', 'EntityRoleController@create')`,
    root: API_ROOT_URL,
    path: '/entity-roles/:type/:id/create',
    method: 'POST',
    fields: ['name', 'active', 'permissions'],
    fieldTypes: {},
    transform: createTransform(entityRoleSchema, 'data'),
}

export const entityRole_edit_Api = {
    backend: `// Route::post('entity-roles/{role_id}/edit', 'EntityRoleController@update')`,
    root: API_ROOT_URL,
    path: '/entity-roles/:role_id/edit',
    method: 'POST',
    fields: ['name', 'active', 'permissions'],
    fieldTypes: {},
    transform: createTransform(entityRoleSchema, 'data'),
}

export const entityRole_delete_Api = {
    backend: `// Route::post('entity-roles/{role_id}/delete', 'EntityRoleController@delete')`,
    root: API_ROOT_URL,
    path: '/entity-roles/:role_id/delete',
    method: 'POST',
    fields: [],
    fieldTypes: {},
    transform: createTransform(entityRoleSchema, 'data'),
}

export const entityRole_setPermissions_Api = {
    backend: `// Route::post('entity-roles/{role_id}/set-permissions', 'EntityRoleController@setPermissions')`,
    root: API_ROOT_URL,
    path: '/entity-roles/:role_id/set-permissions',
    method: 'POST',
    fields: ['permissions'],
    fieldTypes: {},
    transform: createTransform(entityRoleSchema, 'data'),
}